const CONTRACT_INTERVIEW = 0;
const SELECTED_ORGANIZATION = 1;
const MATERIAL_FILL_STEP = 2;
const SUBMIT_MATERIAL = 3;
const WX_REFUSED = 4;
const WX_ACCOUNT_VERIFY = 5;
const WX_PASSED = 6;
const WAIT_SIGN = 7;
const SIGNED = 8;

export  {CONTRACT_INTERVIEW, SELECTED_ORGANIZATION, MATERIAL_FILL_STEP, SUBMIT_MATERIAL, WX_PASSED, WX_REFUSED, WX_ACCOUNT_VERIFY, WAIT_SIGN, SIGNED}